import ZsdbApi from '@/api/ZSDB/zsdbApi';
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async create({dispatch}) {
      try {
        await ZsdbApi.create();
        return Promise.resolve();
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
